const { SENDING_STATUS } = require('../constants/_sendings')
const { WEBHOOK_EVENTS } = require('../constants/misc')
const { isURL } = require('../validators')

const { $defaulter } = require('./utils')

const webhookDefaultValues = {
  url: '',
  method: '',
  headers: '',
  body: '',
  maxConnections: 10,
  successOn: {
    status: '200',
    body: ''
  },
  extras: {}
}
const extrasByEventName = {
  [WEBHOOK_EVENTS.onStatusChange](extras = {}) {
    return {
      statuses: SENDING_STATUS.reduce((object, status) => {
        return Object.assign(object, {
          [status]:
            (extras && extras.statuses && extras.statuses[status] && ('' + extras.statuses[status]).trim()) || status
        })
      }, {})
    }
  }
}

const generateWebhooksHandler = (events = []) => {
  return v => {
    return events.reduce((object, event) => {
      const source = (v && v[event]) || webhookDefaultValues

      source.maxConnections = parseInt(source.maxConnections)
      if (source.maxConnections < 1 || isNaN(source.maxConnections)) {
        source.maxConnections = 1
      } else if (source.maxConnections > 100) {
        source.maxConnections = 100
      }

      return Object.assign(object, {
        [event]: {
          url: (isURL(source.url, 'HTTPsSimpleNotLH') && source.url) || '',
          method: (!!~[ 'POST', 'GET' ].indexOf(source.method) && source.method) || '',
          headers: ('' + source.headers).trim(),
          body: ('' + source.body).trim(),
          maxConnections: source.maxConnections,
          successOn: {
            status: source.successOn && ('' + source.successOn.status).trim(),
            body: source.successOn && ('' + source.successOn.body).trim()
          },
          extras: extrasByEventName[event] ? extrasByEventName[event](source.extras || {}) : {}
        }
      })
    }, {})
  }
}

module.exports = {
  $default: WEBHOOK_EVENTS.reduce((result, eventName) => {
    return Object.assign(result, {
      [eventName]: Object.assign({}, webhookDefaultValues, {
        extras: extrasByEventName[eventName] ? extrasByEventName[eventName]({}) : {}
      })
    })
  }, {}),
  $handler: generateWebhooksHandler(WEBHOOK_EVENTS),
  $cleaner: value => {
    const result = {}

    for (const event of WEBHOOK_EVENTS) {
      result[event] = {}

      const source = (value && value[event]) || webhookDefaultValues
      for (const key in source) {
        const value = source[key]
        switch (key) {
          case 'url': {
            result[event][key] = (isURL(value, 'HTTPsSimpleNotLH') && value) || ''
            break
          }

          case 'method': {
            result[event][key] = (!!~[ 'POST', 'GET' ].indexOf(value) && value) || ''
            break
          }

          case 'headers':
          case 'body': {
            result[event][key] = ('' + value).trim()
            break
          }

          case 'maxConnections': {
            let maxConnections = parseInt(value)
            if (maxConnections < 1 || isNaN(maxConnections)) {
              maxConnections = 1
            } else if (maxConnections > 100) {
              maxConnections = 100
            }
            result[event][key] = maxConnections
            break
          }

          case 'successOn': {
            result[event][key] = {}
            for (const prop of [ 'status', 'body' ]) {
              result[event][key][prop] = (value && value[prop] && ('' + value[prop]).trim()) || ''
            }
            break
          }

          case 'extras': {
            result[event][key] = extrasByEventName[event] ? extrasByEventName[event](value || {}) : {}
            break
          }
        }
      }
    }

    return result
  },
  $defaulter
}
